exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group-shell-nav-tabs {\n  padding-left: 0;\n}\n.users {\n  padding-left: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/group-shell/group-shell.component.less
// module id = ../../../../../src/app/dashboard/program-list/program/groups/group-shell/group-shell.component.less
// module chunks = 2